import { useTranslation } from "react-i18next";

import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import CreateAppendixForm from "./CreateAppendixForm";

export default function CreateAppendixButton({ ...props }) {
	const { t } = useTranslation();

	return (
		<OpenButton text={t("createAppendix", "Create appendix")} {...props}>
			{({ setOpen }) => <CreateAppendixForm onClose={() => setOpen(false)} />}
		</OpenButton>
	);
}
